import { createMuiTheme } from '@material-ui/core';
import { UserTypesEnum } from 'features/account/profile';
import { permanent } from './_themes/permanent.theme';
import { substitute } from './_themes/substitute.theme';

export const getSpecificUserTypeTheme = (userType: UserTypesEnum) => {
  const userTheme = userType === UserTypesEnum.regular ? permanent : substitute;
  return createMuiTheme(userTheme);
};
